import { Component, OnInit,ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'app/shared/services/api.service';
import { Lms } from 'app/shared/models/lms';
import { StrapiApiService } from 'app/shared/services/strapi-api.service';

@Component({
  selector: 'app-course-create',
  templateUrl: './course-create.component.html',
  styleUrls: ['./course-create.component.scss']
})
export class CourseCreateComponent implements OnInit {
   @ViewChild('vform') validationForm: FormGroup;
  courseForm:FormGroup;
   selectedValue:'';
   selectedCourseInterest:''
  tags=[];
  fileData:File;
  selectedCategory=null;
  categoryList=[]
  selectedTag:string[]=[]
  tagsList=[];
  selectedBatch=null
  batchList=[];
  variationList=[];
  selectedVariation=null
  selectedLms:string[]=[]
  courseTagsList=[];
  selectedCourseTag=null
  courseFormSubmitted:boolean=false;
  lmsData: Lms[]
  catId='6319d5025ab9e462a96cfbba'
  skillId='6319d3595ab9e462a96cfb06'
  durationId='631ad5d2ce5c666542591b40'
  courseTagId='631ad5b3ce5c666542591b3c'
  variationId='6532279427098beed312fab4'
  category_tags_list =[]
  selected_category_tags=null

  course_type_List =[
    {displayname:'Internal',_id:'internal'},
    {displayname:'External',_id:'external'},
  ]
  selected_course_type =null
  level_List =[
    {displayname:'Beginner',_id:'beginner'},
    {displayname:'Intermediate',_id:'intermediate'},
    {displayname:'Advanced',_id:'advanced'}
  ]
  selected_level =null
  mode_List =[
    {displayname:'Online',_id:'online'},
    {displayname:'Offline',_id:'offline'},
  ]
  // selected_mode :string[]=[]
  selected_mode =null
  publish_List =[
    {displayname:'True',_id:true},
    {displayname:'False',_id:false},
  ]
  selected_publish_web =null
  selected_publish_app =null
  fullpart_employee_list=[]
  selected_instructor =null
  selected_proofread=null
  selected_publisher=null
  selected_last_publisher = null
  project_list=[]
  workon_id='644a5c52af0db342c32eeaf8'
  selected_project = null
  resource_list=[]
  selected_resource=null
  offers_list=[]
  selected_discount=null
  duration_List =[]
  selected_duration=null
  course_variant_id:any
  offers_category_id:any
  imgUrl: string | ArrayBuffer;

  constructor(private formBuilder: FormBuilder,
    public toastr: ToastrService,
    public apiService:ApiService,
    private strapiService: StrapiApiService,
    private route:Router) {
      this.getAllCategory()
      this.getTagByCategory()
      this.getSkillTagByCategory()
      this.getBatchTagBycategory()
      this.getDurationTagByCategory()
      this.getCourseTagByCategory()
      this.getLmsV1()
      this.getAllTags()
      this.getFullPartEmployee()
      this.getProjectList()
      this.getResourceList()
     }

  ngOnInit(): void {
    this.courseForm=this.formBuilder.group({
    title: ['', Validators.required],
    about: ['', Validators.required],
    preliminarye: ['', Validators.required],
    total_fees: ['', Validators.required],
    benifits: ['', Validators.required], 
    announcements: ['', Validators.required],
    image: ['', Validators.required],
    notes:['', ],
    admin_notes:['', ],
    learning_audience:['', ],
    outcome:['', ],
    objective:['', ],
    min_fees:['', ],
    max_fees:['', ],
    serviceandoffer:['',],
    grading:['', ],
    certification:['', ],
    published_datetime:['', ],
    version:['', ],
    language:['', ],
    promotional_video:['',],

  })
  }
  getAllCategory(){
    this.apiService.getAllCategory(1,100).subscribe((res:any)=>{
      let course_variant = res?.data?.items.filter(item =>item.name =='course_variant')
      this.course_variant_id = course_variant[0]?._id
      let offers_category = res?.data?.items.filter(item =>item.name =='offers_category')
      this.offers_category_id =  offers_category[0]?._id
      if(this.course_variant_id){
        this.getVariationTagByCategory()
      }
      if(this.offers_category_id){
        this.getOfferslist()
      }
    })
  }
  getFullPartEmployee(){
    this.apiService.getFullPartEmployeeList(1,100).subscribe((res:any)=>{
      this.fullpart_employee_list = res?.items
    })
  }
  getProjectList(){
    this.apiService.getJobsByStatus('6428038677a2ab2fb559dc36',1,100,this.workon_id,'current').subscribe((res:any)=>{
      this.project_list=res.data.items
    })
  }
  getResourceList() {
    this.apiService.getResourceList( 1, 100).subscribe((res: any) => {
      this.resource_list = res?.items
    })
  }
  getOfferslist(){
    this.apiService.getTagByTagCatgoryId(this.offers_category_id).subscribe((res: any) => {
      this.offers_list = res?.data
    })
  }
  getAllTags(){
    this.apiService.getTagsList(1,500).subscribe((res:any)=>{
      this.category_tags_list = res?.data?.items
    })
  }
  getCategoryTagsId(event){
    this.selected_category_tags
  }
  getLmsV1() {
     this.strapiService.getLmsV1('').subscribe((res: any) => {
       this.lmsData = res;
     })
   }
   getLmsV1ById(event:any){
    this.selectedLms
   }
  
  getTagByCategory(){
    this.apiService.getTagByTagCatgoryId(this.catId).subscribe((res:any)=>{
      this.categoryList=res.data
    })
   }
   getCategoryId(event:any){
    this.selectedCategory
   }
   getSkillTagByCategory(){
    this.apiService.getTagByTagCatgoryId(this.skillId).subscribe((res:any)=>{
      this.tagsList=res.data
    })
   }
   getTagsId(event:any){
    this.selectedTag
  }
  getBatchTagBycategory(){
    this.apiService.getBatchList(1,100).subscribe((res:any)=>{
      this.batchList=res?.data?.items
    })
   }
   getBatchId(event:any){
    this.selectedBatch
   }
   getDurationTagByCategory(){
    this.apiService.getTagByTagCatgoryId(this.durationId).subscribe((res:any)=>{
      this.duration_List=res.data
    })
   }
   getVariationTagByCategory(){
    this.apiService.getTagByTagCatgoryId(this.course_variant_id).subscribe((res: any) => {
      this.variationList = res?.data
    })
   }
   getVariationId(event:any){
    this.selectedVariation
   }
   getCourseTagByCategory(){
    this.apiService.getTagByTagCatgoryId(this.courseTagId).subscribe((res:any)=>{
      this.courseTagsList=res.data
    })
   }
   getCourseTagId(event:any){
    this.selectedCourseTag
   }
  get rf() {
    return this.courseForm.controls;
  }
 
  submitCourse(){
    let formData:FormData=new FormData()
    // for (let item of this.selectedBatch){
    //   console.log('==>>',item)
    //   formData.append('batch[]',item)
    // }
    for (let item of this.selectedTag){
        formData.append('course_skills[]',item)
      }
      for(let item of this.selectedLms){
        formData.append('lsm_ids[]',item)
      }
      // for(let item of this.selected_mode){
      //   formData.append('mode[]',item)
      // }
      // for(let item of this.selectedCategory){
      //   formData.append('course_skills[]',item)
      // }
    formData.append('title',this.courseForm.value.title),
    formData.append('about',this.courseForm.controls.about.value),
    formData.append('preliminary',this.courseForm.controls.preliminarye.value),
    formData.append('total_fees',this.courseForm.controls.total_fees.value),
    formData.append('benifits',this.courseForm.controls.benifits.value),
    formData.append('announcements',this.courseForm.controls.announcements.value),
    formData.append('course_category',this.selectedCategory),
    formData.append('variations',this.selectedVariation),
    formData.append('course_tags',this.selectedCourseTag),
    formData.append('batch_ids',this.selectedBatch),
    formData.append('notes',this.courseForm.controls.notes.value),
    formData.append('admin_notes',this.courseForm.controls.admin_notes.value),
    formData.append('course_type',this.selected_course_type),
    formData.append('instructor',this.selected_instructor),
    formData.append('proofreaders',this.selected_proofread),
    formData.append('publishers',this.selected_publisher),
    formData.append('projects',this.selected_project),
    formData.append('resources',this.selected_resource),
    formData.append('last_published_by',this.selected_last_publisher),
    formData.append('duration',this.selected_duration),
    formData.append('offers',this.selected_discount),
    formData.append('category',this.selected_category_tags),
    formData.append('level',this.selected_level),
    formData.append('published_web',this.selected_publish_web),
    formData.append('published_app',this.selected_publish_app),
    formData.append('mode',this.selected_mode),
    formData.append('minfees',this.courseForm.controls.min_fees.value),
    formData.append('maxfees',this.courseForm.controls.max_fees.value),
    formData.append('objective',this.courseForm.controls.objective.value),
    formData.append('outcome',this.courseForm.controls.outcome.value),
    formData.append('learning_audience',this.courseForm.controls.learning_audience.value),
    formData.append('language',this.courseForm.controls.language.value),
    formData.append('version',this.courseForm.controls.version.value),
    formData.append('published_datetime',this.courseForm.controls.published_datetime.value),
    formData.append('serviceandoffer',this.courseForm.controls.serviceandoffer.value),
    formData.append('certification',this.courseForm.controls.certification.value),
    formData.append('grading',this.courseForm.controls.grading.value),
    formData.append('promotional_video',this.courseForm.controls.promotional_video.value),
    formData.append('image',this.fileData),

   
     this.apiService.createCourse(formData).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.toastr.success('Create Successfully',res.message)
       this.route.navigate(['/course/course-list']) 
      } 
      else{this.toastr.error(res.error)}  
     })
    // formData.forEach((val,key)=>{
    //   console.log({key,val})
    // })
     this.courseFormSubmitted = true;
     if (this.courseForm.invalid) {
       return;
     }

}
onSelectFile(event:any){
  if (event.target.files && event.target.files[0]) {
    var reader = new FileReader();
    this.fileData = event.target.files[0];
    reader.readAsDataURL(event.target.files[0]);
    reader.onload=(event)=>{
      this.imgUrl=reader.result
    }
  }
}
back(){
this.route.navigate(['/course/course-list'])    
} 
getCourseTypeId(event){
  this.selected_course_type
}
getLevelId(event){
  this.selected_level
}
getModeId(event){
  this.selected_mode
}
getPublishWebId(event){
  this.selected_publish_web
}
getPublishAppId(event){
  this.selected_publish_app
}
getinstructorId(event){
  this.selected_instructor
}
getProofreadId(event){
  this.selected_proofread
}
getPublisherId(event){
  this.selected_publisher
}
getLastPublisherId(event){
  this.selected_last_publisher
}
getProjectId(event){
  this.selected_project
}
getResourceId(event){
  this.selected_resource
}
getDiscountId(event){
  this.selected_discount
}
getDurationId(event){
  this.selected_duration
}





}